type TeamTFunction = (
  key: string,
  options?: Record<string, unknown> & { defaultValue?: string }
) => string;

export const formatTeamMemberNameList = (names: string[], t?: TeamTFunction) => {
  if (names.length <= 1) {
    return names[0] || '';
  }

  if (names.length === 2) {
    if (t) {
      return t('team.common.namePair', { first: names[0], second: names[1] });
    }

    return `${names[0]} and ${names[1]}`;
  }

  if (t) {
    return t('team.common.nameListFinal', {
      names: names.slice(0, -1).join(', '),
      last: names[names.length - 1],
    });
  }

  return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`;
};

export const formatTeamMemberOverflowList = (
  names: string[],
  visibleCount = 3,
  t?: TeamTFunction
) => {
  const visibleNames = names.slice(0, visibleCount);
  const remainingCount = names.length - visibleNames.length;

  if (remainingCount <= 0) {
    return formatTeamMemberNameList(visibleNames, t);
  }

  return formatTeamMemberNameList(
    [
      ...visibleNames,
      t ? t('team.common.moreCount', { count: remainingCount }) : `${remainingCount} more`,
    ],
    t
  );
};

export const sanitizeTeamMemberName = (name: string) => {
  return name.replace(/\s*\(You\)\s*$/, '').trim();
};
